import React from "react";
import TimerPage from "../../components/TimerPage";

const Stage4: React.FC = () => (
  <TimerPage title="4.总结陈词" initialTime={240} />
);

export default Stage4;
